/* eslint-disable react/no-unstable-nested-components */
import { Box, InputLabel, MenuItem, Select } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { ProductUIStyles } from '../StepTwo/ProductUIStyles';
import { REQUIRED } from '../../../constants';
import { CommonStyles } from '../CommonStyles';
import { emplomentStyles as classes } from './EmploymentStyles';
import { DownArrowIcon } from '../../../images/svg/CustomizedSVG';
import { isBundle } from '../../commonCode';

function AnnualIncome(props) {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { theme, productName } = leadGenerationContext;
  const commonStyles = CommonStyles(leadGenerationContext?.theme);
  const styledClasses = ProductUIStyles(leadGenerationContext?.theme);
  const { handleChange, isBundleCompliance = false } = props;

  return (
    <>
      <InputLabel
        htmlFor="annualIncome"
        required={!isBundleCompliance}
        id="annualIncome_label"
        data-testid="annualIncome_label"
        aria-label={
          isBundleCompliance
            ? `${t('Annual income', {
                defaultValue: 'Annual income',
              })} ${t(REQUIRED, { defaultValue: REQUIRED })}`
            : `${t('Annual Income', {
                defaultValue: 'Annual Income',
              })} ${t(REQUIRED, { defaultValue: REQUIRED })}`
        }
        sx={commonStyles.label_title}
      >
        {isBundleCompliance ? (
          <span
            style={{
              color: leadGenerationContext.employmentInformationErrors?.annualIncome
                ? 'red'
                : 'inherit',
            }}
          >
            {t('Annual income', { defaultValue: 'Annual income' })}
          </span>
        ) : (
          t('Annual Income', { defaultValue: 'Annual Income' })
        )}
      </InputLabel>
      <Select
        name="annualIncome"
        fullWidth
        data-testid="annulaIncome_testid"
        variant="outlined"
        aria-label={t('Annual Income Aria Label', {
          defaultValue: 'Annual Income Required Please Select Annual Income dropdown menu button',
        })}
        IconComponent={() => (
          <Box padding="0 10px 0 0">
            <DownArrowIcon
              style={{ width: 24, height: 24 }}
              color={theme?.palette?.orientalPrimary?.main}
            />
          </Box>
        )}
        MenuProps={{
          disableScrollLock: true,
          PaperProps: {
            sx: {
              ...theme?.menuBackground,
              border: `1px solid ${theme?.menuBackground?.borderColor} !important`,
              color: theme?.palette?.primary?.main,
            },
            className: isBundle(productName) ? 'bundle-menu-paper' : '',
          },
        }}
        id="annualIncome"
        // sx={[
        //   classes.select_inputs,
        //   leadGenerationContext.employmentInformationErrors?.annualIncome &&
        //     !isBundleCompliance &&
        //     classes.select_inputs_err,
        //   leadGenerationContext.employmentInformationErrors?.annualIncome &&
        //     isBundleCompliance &&
        //     classes.select_inputs_err_bundle,
        //   !leadGenerationContext.employmentInformation?.annualIncome && {
        //     color: '#808285',
        //   },
        //   ...(isBundleCompliance
        //     ? [classes.select_inputs_bundleBorder, commonStyles.outlined_input_bundle]
        //     : []),
        // ]}
        sx={[
          classes.select_inputs,
          leadGenerationContext.employmentInformationErrors?.annualIncome && !isBundleCompliance
            ? classes.select_inputs_err
            : null,
          leadGenerationContext.employmentInformationErrors?.annualIncome && isBundleCompliance
            ? classes.select_inputs_err_bundle
            : null,
          !leadGenerationContext.employmentInformation?.annualIncome ? { color: '#808285' } : null,
          ...(isBundleCompliance
            ? [
                {
                  '&.Mui-focused': {
                    border: `1px solid ${theme?.palette?.primary?.main}`,
                  },
                },
                classes.select_inputs_bundleBorder,
                commonStyles.outlined_input_bundle,
                {
                  backgroundColor: leadGenerationContext.employmentInformationErrors?.annualIncome
                    ? '#D5151F1A'
                    : theme?.palette?.fieldsBackground?.main,
                  // border: leadGenerationContext.employmentInformationErrors?.annualIncome
                  //   ? `2px solid ${theme?.palette?.danger?.main}`
                  //   : `1px solid ${theme?.palette?.fieldsBorder?.main}`,
                  color: !leadGenerationContext.employmentInformation?.annualIncome
                    ? theme?.palette?.fieldsPlaceholder?.main
                    : theme?.palette?.primary?.main,
                },
              ]
            : []),
        ]}
        slotProps={{
          icon: {
            sx: classes.select_icon,
          },
          select: {
            sx:
              !leadGenerationContext.employmentInformation?.annualIncome ||
              leadGenerationContext.employmentInformation?.annualIncome === 'Please Select'
                ? classes.select_inputs_placeholder
                : classes.select_style,
          },
        }}
        role="listbox"
        onChange={handleChange}
        value={
          leadGenerationContext.employmentInformation?.annualIncome
            ? leadGenerationContext.employmentInformation.annualIncome
            : ''
        }
        displayEmpty
      >
        <MenuItem role="option" value="">
          {isBundleCompliance
            ? t('Select your annual income', { defaultValue: 'Select your annual income' })
            : t('Please Select', { defaultValue: 'Please Select' })}
        </MenuItem>
        <MenuItem role="option" value="Less than $30,000">
          {t('Less than', { defaultValue: 'Less than' })} $30,000
        </MenuItem>
        <MenuItem role="option" value="$30,000 - $49,999">
          {t('$30,000 - $49,999', { defaultValue: '$30,000 - $49,999' })}
        </MenuItem>
        <MenuItem role="option" value="$50,000 - $74,999">
          {t('$50,000 - $74,999', { defaultValue: '$50,000 - $74,999' })}
        </MenuItem>
        <MenuItem role="option" value="$75,000 - $99,999">
          {t('$75,000 - $99,999', { defaultValue: '$75,000 - $99,999' })}
        </MenuItem>
        <MenuItem role="option" value="$100,000 - $199,999">
          {t('$100,000 - $199,999', {
            defaultValue: '$100,000 - $199,999',
          })}
        </MenuItem>
        <MenuItem role="option" value="$200,000 or More">
          $200,000 {t('or More', { defaultValue: 'or More' })}
        </MenuItem>
      </Select>
      <Box
        component="span"
        sx={styledClasses.error_message_product}
        role="alert"
        data-testid="annualErr_id"
      >
        {t(leadGenerationContext.employmentInformationErrors?.annualIncome, {
          defaultValue: leadGenerationContext.employmentInformationErrors?.annualIncome,
        })}
      </Box>
    </>
  );
}

export default AnnualIncome;

AnnualIncome.propTypes = {
  handleChange: PropTypes.func,
  isBundleCompliance: PropTypes.bool,
};
